/**
 * Trajectoire Banner Controller (EPIC-047.4)
 *
 * Invitation banner shown on the dashboard payant (§15.B) at the start
 * of year N+1 if no trajectory has been defined yet. Visible only when
 * the current date is on/after 1 January N+1 AND the trajectory for the
 * current year (N+1 from the previous year's perspective) is absent
 * (HTTP 404 on GET /me/trajectory).
 *
 * Mounted on the `[data-bandeau="trajectoire-invitation-n1"]` aside.
 */

import BaseController from "./base_controller.js";
import { api } from "../services/api.js";

export default class TrajectoireBannerController extends BaseController {
  static targets = ["year", "message", "cta"];

  async connect() {
    this._year = new Date().getFullYear();
    await this.check();
  }

  async check() {
    try {
      await api.get("/me/trajectory", { year: String(this._year) });
      this.element.hidden = true;
    } catch (error) {
      if (error.status === 404) {
        this.reveal();
      } else {
        this.element.hidden = true;
      }
    }
  }

  reveal() {
    if (this.hasYearTarget) this.yearTarget.textContent = String(this._year);
    if (this.hasMessageTarget) {
      this.messageTarget.textContent =
        `L'année ${this._year - 1} est terminée — il est temps de définir votre nouvel objectif annuel et de piloter votre activité tout au long de l'année.`;
    }
    if (this.hasCtaTarget) {
      this.ctaTarget.setAttribute("href", `/pilotage-trajectoire-edition.html?trajectoryYear=${this._year}`);
    }
    this.element.hidden = false;
  }
}
